import React from 'react';
import type ScreenSchemesPageType from '@jira/admin-pages__screen-schemes-page/src/ScreenSchemesPage.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyScreenSchemesPage = lazyForPaint<typeof ScreenSchemesPageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-screen-schemes-page", jiraSpaEntry: "async-jira-admin-pages-screen-schemes-page" */ '@jira/admin-pages__screen-schemes-page/src/ScreenSchemesPage.tsx'
		),
	),
);

const AsyncScreenSchemesPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyScreenSchemesPage}
		pageId="jira-admin-pages-screen-schemes-page"
		shouldShowSpinner
	/>
);

export default AsyncScreenSchemesPage;
